import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';

import { closeErrorModal } from '../../actions/errors';

const ErrorModal = () => {
  const {
    modalOpen = false,
    message = 'There was an unexpected error.'
  } = useSelector(state => state.errors);

  const dispatch = useDispatch();

  return (
    <Dialog
      open={modalOpen}
      aria-labelledby="error-modal-title"
      aria-describedby="error-modal-description"
      PaperProps={{
        style: { minWidth: 450, minHeight: 162 }
      }}
    >
      <DialogTitle>
        An Error Occurred
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          {message}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={() => dispatch(closeErrorModal())}
          color="primary"
          autoFocus
        >
          Okay
        </Button>
      </DialogActions>
    </Dialog>
  )
};

export default ErrorModal;
